import { render, staticRenderFns } from "./deptMultiHazardPop.vue?vue&type=template&id=2c7a428c"
import script from "./deptMultiHazardPop.vue?vue&type=script&lang=js"
export * from "./deptMultiHazardPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7a428c')) {
      api.createRecord('2c7a428c', component.options)
    } else {
      api.reload('2c7a428c', component.options)
    }
    module.hot.accept("./deptMultiHazardPop.vue?vue&type=template&id=2c7a428c", function () {
      api.rerender('2c7a428c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/deptMultiHazardPop.vue"
export default component.exports